@if (props$ | async; as props) {
    <div class="pc-text betslip-edit-bet__error-message" [class.is-empty]="!props.isVisible">
        @if (props.isVisible) {
            <bs-betslip-edit-my-bet-notification [notification]="props.notification" />
        }
    </div>
}
